module.exports = __webpack_public_path__ + "static/media/GDocsCookieNotice_ES.18e0f36b.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/staff_PDF/GDocsCookieNotice_ES.pdf
// module id = 690
// module chunks = 4